import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Loader from './components/Header/Loader.jsx';
import { useTranslationMonitor } from './hooks/useTranslationMonitor.js';

// Importações de páginas
import Home from './pages/home/home.jsx';
import Noticias from './pages/comunicacao/noticias/index.jsx';
import NoticiaDetalhes from './pages/comunicacao/noticias/noticiasDetalhes.jsx';
import Eventos from './pages/comunicacao/evento/index.jsx';
import EventosDetalhes from './pages/comunicacao/evento/eventosDetalhes.jsx';

import Instituicao from './pages/instituicao/index.jsx';
import OrganigramaInstituicao from './pages/instituicao/Organigrama.jsx';
import MissaInstituicaoInstituicao from './pages/instituicao/missao_visao_valores.jsx';
import PalavraPresidenteInstituicao from './pages/instituicao/palavra-do-presidente.jsx';
import PerguntasFrequentesInstituicao from './pages/instituicao/perguntas-frequentes.jsx';
import AccaoSocial from './pages/instituicao/apoio-social.jsx';
import Legalidade from './pages/instituicao/legalidade.jsx';
import Decretos from './pages/instituicao/decretos.jsx';
import Regulamentos from './pages/instituicao/regulamentos.jsx';

import UnidadeOrganica from './pages/programas/unidade_organica/index.jsx';
import Licenciatuara from './pages/programas/licenciatura.jsx';
import DocentesCS from './pages/programas/unidade_organica/ciencia_saude/docentes.jsx';
import MissaoCS from './pages/programas/unidade_organica/ciencia_saude/missao-visao-valores.jsx';
import CienciaSaude from './pages/programas/unidade_organica/ciencia_saude/index.jsx';
import CienciaHumanas from './pages/programas/unidade_organica/ciencia_Humanas/index.jsx';
import MissaoVisaoValoresHumanas from './pages/programas/unidade_organica/ciencia_Humanas/miss-viss-valores-humanas.jsx';

import PorqueISpa from './pages/internacional/porque-ispa.jsx';
import EstudanteInternacional from './pages/internacional/estudante-internacional.jsx';
import CursosInt from './pages/internacional/licenciatura.jsx';
import Alojamento from './pages/internacional/alojamento.jsx';

import Jornada from './pages/investigacao/index.jsx';
import SubmissaoResumo from './pages/investigacao/submissao-resumo.jsx';
import BibliotecaVirtual from './pages/investigacao/bibliotecaVirtual.jsx';

import CursoOnline from './pages/estudantes/p_online/index.jsx';
import Candidatura from './pages/estudantes/p_online/PublicApplicationForm.js';
import DetalhesLicenciatura from './pages/programas/detalhesLicenciatura.jsx';
import PainelAdmin from './pages/estudantes/p_online/AdminPanel.js';

import NotFound from './pages/notfound.jsx'


function AppRoutes() {
  const location = useLocation();
  const [routeChanging, setRouteChanging] = useState(false);
  const isTranslating = useTranslationMonitor();
  const [currentPath, setCurrentPath] = useState(location.pathname);

  useEffect(() => {
    if (location.pathname !== currentPath) {
      setRouteChanging(true);
      setCurrentPath(location.pathname);
    }
  }, [location, currentPath]);

  useEffect(() => {
    if (!isTranslating && routeChanging) {
      const timer = setTimeout(() => setRouteChanging(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isTranslating, routeChanging]);

  const showLoader = routeChanging || isTranslating;

  return (
    <>
      {showLoader && <Loader />}
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/comunicacao/noticias" element={<Noticias />} />
        <Route path="/comunicacao/noticias/:id" element={<NoticiaDetalhes />} />
        <Route path="/comunicacao/eventos" element={<Eventos />} />
        <Route path="/comunicacao/eventos/:id" element={<EventosDetalhes />} />

        <Route path="/instituicao" element={<Instituicao />} />
        <Route path="/instituicao/organigrama" element={<OrganigramaInstituicao />} />
        <Route path="/instituicao/missao-visao-valores" element={<MissaInstituicaoInstituicao />} />
        <Route path="/instituicao/palavra-do-presidente" element={<PalavraPresidenteInstituicao />} />
        <Route path="/instituicao/perguntas-frequentes" element={<PerguntasFrequentesInstituicao />} />
        <Route path="/instituicao/apoio-social" element={<AccaoSocial />} />
        <Route path="/instituicao/legalidade" element={<Legalidade />} />
        <Route path="/instituicao/decretos" element={<Decretos />} />
        <Route path="/instituicao/regulamentos" element={<Regulamentos />} />

        <Route path="/programas/licenciatura" element={<Licenciatuara />} />
        <Route path="/programas/licenciatura/detalhes-cursos/:id" element={<DetalhesLicenciatura />} />

        <Route path="/programas/unidade-organica" element={<UnidadeOrganica />} />
        <Route path="/programas/unidade-organica/ciencia-saude" element={<CienciaSaude />} />
        <Route path="/programas/unidade-organica/ciencia-saude/docentes" element={<DocentesCS />} />
        <Route path="/programas/unidade-organica/ciencia-saude/missao-visao-valores" element={<MissaoCS />} />
        <Route path="/programas/unidade-organica/ciencia-humanas" element={<CienciaHumanas />} />
        <Route path="/programas/unidade-organica/ciencia-humanas/missao-visao-valores" element={<MissaoVisaoValoresHumanas />} />

        <Route path="/internacional/porque-ispa" element={<PorqueISpa />} />
        <Route path="/internacional/estudante" element={<EstudanteInternacional />} />
        <Route path="/internacional/licenciatura" element={<CursosInt />} />
        <Route path="/internacional/alojamento" element={<Alojamento />} />
        <Route path="/investigacao/jornada-cientifica" element={<Jornada />} />
        <Route path="/investigacao/submissao-resumo" element={<SubmissaoResumo />} />
        <Route path="/investigacao/Biblioteca-virtual" element={<BibliotecaVirtual />} />

        <Route path="/comunicacao/eventos" element={<Eventos />} />
        <Route path="/comunicacao/noticias" element={<Noticias />} />

        <Route path='/portal-do-estudante/cursos-online' element={<CursoOnline />} />
        <Route path='/portal-do-estudante/Candidatura-online' element={<Candidatura />} />
        <Route path='/portal-do-estudante/admin-Candidatura' element={<PainelAdmin />} />

         <Route path="*" element={<NotFound />} />

      </Routes>
    </>
  );
}

function App() {
  const [initialLoad, setInitialLoad] = useState(true);
  const isTranslating = useTranslationMonitor();

  useEffect(() => {
    if (!isTranslating) {
      const timer = setTimeout(() => setInitialLoad(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [isTranslating]);

  return (
    <>
      {(initialLoad || isTranslating) && <Loader />}
      <Router>
        <AppRoutes />
      </Router>
    </>
  );
}

export default App;